import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '../../app.store';

const activePlaceIdSelector = (state: AppState) => state.frontendState.places.activePlaceId;
export const useActivePlaceIdSelector = () => useSelector(activePlaceIdSelector);

export const placesSearchResultsSelector = (state: AppState) => state.frontendState.places.searchResults;
export const usePlacesSearchResultsSelector = () => useSelector(placesSearchResultsSelector);
